module.exports = __webpack_public_path__ + "static/images/logo_main.a8dc5d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_main.png
// module id = 206
// module chunks = 2